/**
 * Os aceites da avaliadora vencidos no escopo da sessão (`TP-065`, `D6`): o número do item "Fila da avaliação" no menu.
 *
 * Mora em `shared/` porque quem lê é a barra lateral e quem muda o dado é o detalhe do Caso — uma feature não importa a
 * outra. A chave fica SOB a raiz `fila-da-avaliadora`: invalidar a raiz (o que o painel faz depois de acionar ou
 * aceitar) atualiza o número também.
 */

import { queryOptions } from '@tanstack/react-query';
import type { Schemas } from '@anery/api-contracts';

import { requisitar } from '../api/clienteHttp';

export const RAIZ_DA_FILA_DA_AVALIADORA = ['fila-da-avaliadora'] as const;

/** Só os vencidos (a lista mais curta); o `vencidos` da resposta conta o escopo inteiro, sem o filtro. */
export function vencidosDaAvaliacao() {
  return queryOptions({
    queryKey: [...RAIZ_DA_FILA_DA_AVALIADORA, 'vencidos'] as const,
    queryFn: ({ signal }) =>
      requisitar<Schemas['FilaDaAvaliadoraResponse']>('/fila-da-avaliadora?situacao=aceite_vencido', {
        sinal: signal,
      }).then((fio) => fio.vencidos),
    refetchInterval: 60_000,
    // Modo mock (503) ou falha: o menu segue sem número, e a tela da fila diz o erro.
    retry: false,
  });
}
